<!-- Chat Bubble -->
<div class="c-chat-bubble" *ngIf="!isOpen" (click)="toggleChat()">
  <div class="c-chat-bubble__btn">
    <img class="c-chat-bubble__icon" src="../../assets/theme/lia-bubble.gif" alt="Lia Chat">
  </div>
  <div class="c-chat-bubble__info" *ngIf="showBubbleInfo">
    <span class="s">
      I'm your AI travel assistant! <br/>I'm here to help you find your dream stay in Dubai!
    </span>
  </div>
</div>

<!-- Chat Panel (open) -->
<div class="c-chat-panel" *ngIf="isOpen">
  <div class="c-chat-panel__main">
    <div class="c-chat-panel__control-bar">
      <span class="c-chat-panel__title">
        <svg class="a-icon c-chat-panel__icon"><use xlink:href="#lia"></use></svg>
      </span>
      <div class="c-chat-panel__actions">
        <button class="a-link-btn a-link-btn--strong c-chat-panel__ctrl-btn">
          <svg class="a-icon">
            <use xlink:href="#compress"></use>
          </svg>
        </button>
        <button class="a-link-btn a-link-btn--strong c-chat-panel__ctrl-btn" (click)="toggleChat()">
          <svg class="a-icon u-x0.75">
            <use xlink:href="#close"></use>
          </svg>
        </button>
      </div>
    </div>

    <div class="c-chat-panel__content" #chatContent>
      <div class="c-chat-box">

        <!-- Greeting / Intro -->
        <div class="c-chat-box__intro">
          <div class="c-chat-box__greeting">
            <div class="c-chat-box__intro-title">Hello <span
              class="ts-bold">{{ user?.userSummary?.firstName || 'Guest' }}</span> 👋
            </div>
            <span class="s-large c-chat-box__intro-txt tc-muted">
              Need hotel recommendations in Dubai? <br/>Let's find the best fit for you!
            </span>
          </div>

          <!-- Quick Suggestions -->
          <div class="c-chat-box__suggestions" *ngIf="suggestions.length">
            <button class="c-chat-box__suggestion-item"
                    *ngFor="let suggestion of suggestions"
                    (click)="sendSuggestion(suggestion)">
              <span class="s">{{ suggestion }}</span>
              <svg class="a-icon">
                <use xlink:href="#arrow-up-right"></use>
              </svg>
            </button>
          </div>
        </div>

        <!-- Messages Loop -->
        <ng-container *ngFor="let msg of messages">
          <app-chat-message [message]="msg"
                            [handleSuggestionClick]="handleSuggestionClick.bind(this)"></app-chat-message>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- Input Bar -->
  <!-- Input Bar -->
  <div class="c-chat-panel__input">
    <div class="c-chat-input">
      <button class="a-link-btn c-chat-input__btn c-chat-input__btn--add" [disabled]="isProcessing">
        <svg class="a-icon">
          <use xlink:href="#plus"></use>
        </svg>
      </button>
      <input
        type="text"
        class="c-chat-input__field"
        placeholder="Ask anything"
        [(ngModel)]="inputMsg"
        (keyup.enter)="isProcessing ? null : sendMessage()"
      />
      <button class="a-link-btn c-chat-input__btn c-chat-input__btn--mic" [disabled]="isProcessing">
        <svg class="a-icon">
          <use xlink:href="#microphone"></use>
        </svg>
      </button>
      <button
        class="a-btn a-btn--primary c-chat-input__btn c-chat-input__btn--send"
        (click)="sendMessage()"
        [disabled]="isProcessing"
      >
        <svg class="a-icon">
          <use xlink:href="#send-line"></use>
        </svg>
      </button>
    </div>
  </div>
</div>
